import { useContext } from "react";
import Context from "../../Context";

const useContactUs = ({ fullName, email, contactTitle, contactBody }) => {
  const context = useContext(Context);

  return () => {
    context.notification(
      "پیام شما در حال ارسال است ... لطفا صبر کنید.",
      "warning",
    );
    context.ApiDriver.contactUs(
      {
        fullName: fullName,
        email: email,
        title: contactTitle,
        body: contactBody,
      },
      data => {
        context.notification("پیام شما با موفقیت ارسال شد", "success");
        context.modal.show();
      },
      error => {
        console.log(error);
        context.notification("ارسال پیام با خطا مواجه شد", "error");
      },
    );
  };
};

export default useContactUs;
